module.exports = __webpack_public_path__ + "static/media/Default_product.87bf800d.svg";